import React, { useState } from 'react';
import {
  Container,
  Box,
  Paper,
  Typography,
  Tabs,
  Tab,
  Alert,
  Grid,
  Fade,
  Grow,
  // Divider is not used in this component
  // Divider,
  Chip
} from '@mui/material';
import ScienceIcon from '@mui/icons-material/Science';
import DescriptionIcon from '@mui/icons-material/Description';
import ApiKeyInput from '../components/ApiKeyInput';
import SearchSection from '../components/search/SearchSection';
import PapersList from '../components/papers/PapersList';
import ReviewGenerator from '../components/review/ReviewGenerator';
import ReviewDisplay from '../components/review/ReviewDisplay';
import { useAppContext } from '../contexts/AppContext';

function Home({ children }) {
  const { apiKeySet, error, papers } = useAppContext();
  const [activeTab, setActiveTab] = useState(0);
  const [paperAbstract, setPaperAbstract] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Function to switch tabs programmatically
  const switchToTab = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <Container maxWidth="xl" sx={{ pt: 2, pb: 3, mt: 6 }}>
      {/* Render children (DisclaimerBanner) if provided */}
      {children}

      {!apiKeySet && (
        <Grow in={!apiKeySet}>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              mb: 4,
              borderRadius: 'var(--border-radius-lg)',
              border: '1px solid var(--primary-200)',
              background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.08) 0%, rgba(255, 255, 255, 0.9) 100%)',
              boxShadow: 'var(--card-shadow)'
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{
                fontWeight: 700,
                color: 'var(--primary)',
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              <ScienceIcon /> Set Your OpenAI API Key
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: 'var(--neutral-600)' }}>
              Enter your OpenAI API key to start using LitLLM and explore academic papers
            </Typography>
            <ApiKeyInput />
          </Paper>
        </Grow>
      )}

      {error && (
        <Fade in={!!error}>
          <Alert
            severity="error"
            sx={{
              mb: 3,
              borderRadius: 'var(--border-radius-md)',
              border: '1px solid var(--error-200)'
            }}
          >
            {error}
          </Alert>
        </Fade>
      )}

      <Grid container spacing={3}>
        {/* Left column - Search & Papers (Retriever) - Reduced to 60% */}
        <Grid item xs={12} md={7} lg={7}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: 'var(--border-radius-lg)',
              border: '1px solid var(--neutral-200)',
              overflow: 'hidden',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: 'var(--card-shadow)'
            }}
          >
            <Box sx={{ flex: 1, overflow: 'auto', p: 0 }}>
              <SearchSection
                abstract={paperAbstract}
                setAbstract={setPaperAbstract}
                isGenerating={isGenerating}
              />
              <PapersList />
            </Box>
          </Paper>
        </Grid>

        {/* Right column - Generate & View Review - Increased to 40% */}
        <Grid item xs={12} md={5} lg={5}>
          {papers.length === 0 ? (
            <Paper
              elevation={0}
              sx={{
                borderRadius: 'var(--border-radius-lg)',
                border: '1px solid var(--neutral-200)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: 'var(--card-shadow)',
                p: 4
              }}
            >
              <DescriptionIcon sx={{ fontSize: 70, color: 'var(--neutral-300)', mb: 3 }} />
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, textAlign: 'center' }}>
                Generation
              </Typography>
              <Typography variant="body2" sx={{ color: 'var(--neutral-500)', textAlign: 'center', maxWidth: '80%' }}>
                Search and select papers on the left to unlock generation features
              </Typography>
            </Paper>
          ) : (
            <Grow in={papers.length > 0} timeout={800}>
              <Paper
                elevation={0}
                sx={{
                  borderRadius: 'var(--border-radius-lg)',
                  border: '1px solid var(--neutral-200)',
                  overflow: 'hidden',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  boxShadow: 'var(--card-shadow)',
                  position: 'relative'
                }}
              >

                <Box sx={{ flex: 1, overflow: 'auto', p: 0 }}>
                  <ReviewGenerator
                    abstract={paperAbstract}
                    setAbstract={setPaperAbstract}
                    setIsGenerating={setIsGenerating}
                  />
                </Box>
              </Paper>
            </Grow>
          )}
        </Grid>
      </Grid>
    </Container>
  );
}

export default Home; 